import { Capacitor } from '@capacitor/core'
import api from '../services/api'
import { recordarTokenNativo } from './bajaPush'
import { idDelDispositivo } from '../utils/dispositivo'
// t478 · varias cuentas en la misma app (como Gmail): el teléfono se apunta con cada una, y al tocar el aviso de otra, pasa a ella.
import { idsDeLasDormidas, apuntarLasDormidas, rutaParaAbrirAviso } from '../utils/cuentasDelDispositivo'
import { t as i18nT } from '../utils/i18n'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

// Registra el dispositivo para push (FCM) SOLO cuando la app corre dentro del
// envoltorio nativo de Capacitor. En el navegador de escritorio no hace nada
// (isNativePlatform() === false) → el Web Push de escritorio va por otra vía.
//
// IMPORTANTE: este archivo importa '@capacitor/core', así que SOLO debe
// importarse desde App.jsx DESPUÉS de instalar los paquetes de Capacitor en el
// frontend (npm i @capacitor/core @capacitor/app @capacitor/push-notifications).
// Mientras no se importe desde ningún sitio, queda inerte y no afecta al build web.
// B-914 · los oyentes se ponen UNA vez por arranque de la app (esta función se llama en cada inicio de sesión).
let _oyentes = false
// B-914 · pedirle al Busca que pregunte al servidor qué sigue sonando (components/busca/BuscaEntrante).
const alDiaElBusca = () => { try { window.dispatchEvent(new CustomEvent('biango-busca', { detail: { tipo: 'sincronizar' } })) } catch { } }
// t398 · la plataforma con la que se registra este teléfono para los avisos. Pura: la mide la guardia.
export function plataformaDeAvisos(cap = Capacitor) {
  const p = cap.getPlatform()
  try { if (p === 'android' && typeof cap.isPluginAvailable === 'function' && cap.isPluginAvailable('BuscaAlarma')) return 'android-alarma' } catch { }
  return p
}

export async function registrarPush(navigate) {
  if (!Capacitor.isNativePlatform()) return

  // B-875 · EL COMPLEMENTO DE VIBRACIÓN (Capacitor Haptics): importarlo lo registra en Capacitor.Plugins, que es donde lo
  // busca utils/vibrar para que el Busca vibre sin parar DENTRO de la app. Solo en la app (en el navegador no se carga) y
  // antes de pedir el permiso de avisos, que puede no darse. Una app compilada antes de llevarlo no lo tiene dentro:
  // utils/vibrar lo mira (isPluginAvailable) y sigue con lo que haya.
  import('@capacitor/haptics').catch(() => {})

  // Anti-duplicado: si el webview tenía una suscripción Web Push, quítala (en nativo el push
  // va por FCM). Sin esto, el mismo móvil recibiría el aviso dos veces (FCM + web).
  try {
    const reg = navigator.serviceWorker && await navigator.serviceWorker.getRegistration()
    const sub = reg && await reg.pushManager.getSubscription()
    if (sub) {
      try { await api.delete('/push/registrar', { data: { token: JSON.stringify(sub) } }) } catch {}
      try { await sub.unsubscribe() } catch {}
    }
  } catch {}

  const { PushNotifications } = await import('@capacitor/push-notifications')

  // B-914 · LOS OYENTES, ANTES DE register(). Se ponían DESPUÉS, y el token que devuelve el registro llega cuando llega: si
  // llegaba antes que el oyente, se perdía y ese teléfono no quedaba apuntado para recibir avisos (el busca no le sonaba).
  const primeraVez = !_oyentes
  _oyentes = true
  // Token del dispositivo → backend (tabla push_tokens vía POST /api/push/registrar).
  if (primeraVez) PushNotifications.addListener('registration', async (t) => {
    // B-834 · se recuerda para poder darlo de baja al cerrar sesión (push/bajaPush).
    recordarTokenNativo(t.value)
    // t398 · con el identificador de este dispositivo (utils/dispositivo): el Busca no lo cuenta dos veces. Y una app de
    // Android que lleva dentro el complemento nativo del Busca (frontend/plugins/busca-alarma) se registra como
    // 'android-alarma': el servidor le manda el busca para que lo haga sonar y vibrar sin parar (services/pushSender).
    // t478 · con las demás cuentas abiertas en la app (`cuentas`), para que el servidor no les quite este teléfono; y después
    // el teléfono apuntado con la sesión de cada una de ellas: le llegan los avisos de todas (utils/cuentasDelDispositivo).
    let cuentas = []
    try { cuentas = idsDeLasDormidas() } catch { cuentas = [] }
    try { await api.post('/push/registrar', { token: t.value, plataforma: plataformaDeAvisos(), dispositivo: idDelDispositivo(), ...(cuentas.length ? { cuentas } : {}) }) } catch {}
    if (cuentas.length) { try { await apuntarLasDormidas({ token: t.value, plataforma: plataformaDeAvisos(), dispositivo: idDelDispositivo() }) } catch {} }
  })
  if (primeraVez) PushNotifications.addListener('registrationError', (e) => { console.warn('[push] no se ha podido registrar este teléfono:', e && (e.error || e)) })
  // B-914 · con la app abierta, un push del busca (el que suena o el que dice que ya se contestó) pone el busca al día
  // aunque la conexión en directo se haya perdido.
  if (primeraVez) PushNotifications.addListener('pushNotificationReceived', (n) => {
    const d = (n && n.data) || {}
    if (d.tipo === 'busca' || d.tipo === 'busca_parar') alDiaElBusca()
  })
  // B-914 · y al volver a la app desde segundo plano.
  if (primeraVez) import('@capacitor/app').then(({ App }) => { App.addListener('appStateChange', (st) => { if (st && st.isActive) alDiaElBusca() }) }).catch(() => {})

  // Al tocar la notificación, navega al sitio adecuado.
  //
  // `d.ruta` MANDA SOBRE TODO LO DEMÁS, igual que en el service worker (public/sw.js, rutaDeData).
  // Sin esto, el push de una mención llevaba al inicio: el aviso decía "te han mencionado" y al
  // tocarlo tocaba buscar el mensaje a mano. Con la ruta, la campana, el push y el número rojo van
  // los tres al MISMO sitio — la conversación, y dentro de ella el mensaje.
  // Se acota a rutas internas: una `ruta` que viniera con host propio sería una redirección fuera.
  if (primeraVez) PushNotifications.addListener('pushNotificationActionPerformed', (a) => {
    const d = a.notification?.data || {}
    // Y si no trae `ruta`, su `url`: es lo que mandan TODOS los avisos del equipo (services/avisosEquipo), y en la app
    // del móvil tocarlos no llevaba a ningún sitio. El service worker de la web ya lo hacía así (public/sw.js).
    const destino = typeof d.ruta === 'string' ? d.ruta : (typeof d.url === 'string' ? d.url : null)
    const ruta = destino && /^\/[^/\\]/.test(destino) ? destino : null
    // t478 · el aviso de OTRA cuenta abierta en la app: primero se pasa a ella (/cambiar-cuenta) y después se abre lo suyo.
    const otra = d.cuenta && rutaParaAbrirAviso(d.cuenta, ruta || '/')
    if (otra) navigate && navigate(otra)
    else if (ruta) navigate && navigate(ruta)
    else if (d.tipo === 'chat') navigate && navigate(d.canalId ? '/chat?c=' + d.canalId : '/')
    else if (d.conversacionId) navigate && navigate('/comunicacion?conv=' + d.conversacionId)
  })

  let perm = await PushNotifications.checkPermissions()
  if (perm.receive === 'prompt') perm = await PushNotifications.requestPermissions()
  if (perm.receive !== 'granted') return
  // B-875 · EL CANAL «busca» DE ANDROID: el aviso del Busca llega en este canal (services/pushSender · canalAndroid) para
  // que vibre y suene con la importancia más alta aunque la app esté cerrada. En iOS no hay canales: no hace nada.
  try {
    if (Capacitor.getPlatform() === 'android' && typeof PushNotifications.createChannel === 'function') {
      await PushNotifications.createChannel({ id: 'busca', name: 'Busca', description: i18nT('push.registrarPush.cuando_alguien_del_equipo_te', 'Cuando alguien del equipo te busca'), importance: 5, visibility: 1, vibration: true })
      // B-914 · el aviso que SUSTITUYE al busca contestado o cancelado en otro dispositivo: importancia baja, sin sonido.
      await PushNotifications.createChannel({ id: 'busca-fin', name: 'Busca contestado', description: i18nT('push.registrarPush.cuando_un_busca_ya_se', 'Cuando un busca ya se ha contestado o cancelado'), importance: 2, visibility: 1, vibration: false })
    }
  } catch {}
  await PushNotifications.register()
}
